import { render, staticRenderFns } from "./ls.vue?vue&type=template&id=4198af19&scoped=true"
import script from "./ls.vue?vue&type=script&lang=js"
export * from "./ls.vue?vue&type=script&lang=js"
import style0 from "./ls.vue?vue&type=style&index=0&id=4198af19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4198af19",
  null
  
)

export default component.exports